module.exports = __webpack_public_path__ + "img/Check.47f8a497.svg";